<template>
    <div id="supplier-banner">
        <!--=====================================-->
        <!--=        Banner Area Start         =-->
        <!--=====================================-->
        <section class="section">
            <div class="container">
                <div 
                    class="project-add-banner bg-gradient-green mb-0" 
                    data-sal="slide-up" 
                    data-sal-duration="1000">
                    <div class="content">
                        <div class="row align-items-center">
                            <div class="col-lg-7 col-xl-7 col-xxl-7">
                                <!-- <span class="subtitle">Alcanza tus metas financieras en automático.</span> -->
                                <h2 class="bold">
                                    Somos la financiera integral para instaladores.
                                </h2>
                                <h4>Crea tu cuenta como instalador y dispara tus ventas con el financiamiento para ti o tus clientes.</h4>
                                <button @click.stop="goToSupplierRegister" class="axil-btn btn-borderd btn-fluid btn-primary rg-style-button-black w-auto">Regístrate</button>
                            </div>
                            <!-- BANNER FORM -->
                            <div class="col-lg-5 col-xl-5 col-xxl-5">
                                <startTodayCard 
                                    :nameHolder="'Rodrigo Gonzalez'" 
                                    :emailHolder="'instalador@solar.com'" 
                                    urlPath="registerSupplier"
                                    originLanding="Instaladores solares"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import startTodayCard from '../partials/start-today-card.vue';
export default {
    name: "CoinsBanner",
    props: ["banner", "isBusiness"],
    components: {
        startTodayCard
    },
    data() {
        return {
            imgBase: "https://cdn.redgirasol.com/nuevo_portal/banners/banner-"
        }
    }
}

</script>

<style scoped>
.form-floating {
    position: relative;
    top: 5rem;
}

.project-add-banner .content {
    padding-right: 0;
}

@media only screen and (max-width: 575px) {
    .form-floating {
        top: 4rem !important;
    }
}

@media only screen and (max-width: 991px) {
    .banner.banner-style-2 {
        top: 4rem !important;
    }
}

</style>